// extracted by mini-css-extract-plugin
module.exports = {"expertRatingContainer":"RatingBadge_expertRatingContainer__vW9Cr","expertRating":"RatingBadge_expertRating__uBxs_","starIcon":"RatingBadge_starIcon__4PdLr"};